import Client from "./client";

export interface StoreExchangeItem {
  id?: number;
  companyId?: number;
  storeExchangeId?: number;
  // "returned" => enters stock | "delivered" => leaves stock
  direction?: string;
  originalSaleItemId?: number;
  clothingProductId?: number;
  productVariantId?: number;
  productCodeIdentifier?: string;
  productName?: string;
  variantName?: string;
  colorId?: number;
  colorName?: string;
  sizeId?: number;
  sizeName?: string;
  amount?: number;
  unitPrice?: number;
  listUnitPrice?: number;
  totalPrice?: number;
  taxType?: string;
  reason?: string;
}

interface StoreExchange {
  id?: number;
  companyId?: number;
  storeId?: number;
  storeName?: string;
  originalSaleId?: number;
  sellerId?: number;
  sellerName?: string;
  clientId?: number;
  client?: Client;
  clientName?: string;
  clientDocument?: string;
  exchangeDate?: string;
  returnedTotal?: number;
  deliveredTotal?: number;
  priceDifference?: number;
  reason?: string;
  obs?: string;
  reverted?: boolean;
  revertedAt?: string;
  revertedById?: number;
  revertedByName?: string;
  revertReason?: string;
  revertObs?: string;
  cashRegisterOperationId?: number;
  differenceSaleId?: number;
  items?: StoreExchangeItem[];
}

export const newStoreExchange = (): StoreExchange => {
  return {};
};

// Color for the price-difference badge. priceDifference = delivered - returned.
// delivered > returned => store gives more value => red.
// returned > delivered => store keeps the surplus => green.
export const getExchangeDifferenceColor = (
  priceDifference?: number
): string => {
  const diff = priceDifference || 0;
  if (diff > 0) return "danger";
  if (diff < 0) return "success";
  return "secondary";
};

// Short, unambiguous label describing the value flow for the store.
export const getExchangeDifferenceLabel = (
  priceDifference?: number
): string => {
  const diff = priceDifference || 0;
  if (diff > 0) return "Tienda entrega de más";
  if (diff < 0) return "Tienda recibe de más";
  return "Sin diferencia";
};

export const getReturnedItems = (
  exchange: StoreExchange
): StoreExchangeItem[] => {
  return (exchange.items || []).filter((i) => i.direction === "returned");
};

export const getDeliveredItems = (
  exchange: StoreExchange
): StoreExchangeItem[] => {
  return (exchange.items || []).filter((i) => i.direction === "delivered");
};

export default StoreExchange;
